import React, { useState, useEffect, useMemo, useRef } from "react";
import "../../Assests/Scss/AddEdit.scss";
import axios from "axios";
import Loading from "../../../../Student/Reusablecomponents/Loading";

import TinyMCEDitor from "../../../../ReusableComponents/tinymceEditor";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  MainSource,
  SubMainSource,
} from "../../../../ReusableComponents/QBDropdowns";
import {
  Situation,
  TextFormat,
  TType,
  GradeDD,
  ChapterDD,
  BookDD,
  Booktype,
  BookTypeSubDropDowns,
  // Stage, CircularGoal, CompetenciesDD,
  UnitNumber,
  UnitName,
} from "../../../../ReusableComponents/QBEnglishDropdowns";
import BookSubDropDowns from "../../../../ReusableComponents/QBEnglishDropdowns";
import {
  StageDD, CircularGoalDD, CompetenciesDD,
} from "../../../../ReusableComponents/QBAdmin/CommonDropdowns";
import axiosInstance from "../../../../ReusableComponents/Axios";
import notify from "../../../../ReusableComponents/ToastifyAlerts";
import AP from "../../Assests/images/AParameters.svg";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IoMdCloseCircleOutline } from "react-icons/io";
import * as Yup from "yup";
import QBCList from "../../../../ReusableComponents/QBCheckList";
import DataTable from "../../../../Student/Reusablecomponents/DataTable/DataTable";
const EAddEditScenario = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const BookRef = useRef();
  const BookTypeRef = useRef();
  const BTCore = "Core";
  const BTElective = "Elective";
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const updateScenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );

  const [Load, SetLoad] = useState(false);
  const [NTDeatils, SetNTDeatils] = useState(updateScenario?.mainSourceLovId);
  const [NTBased, SetNTBased] = useState(updateScenario?.sSourceLovId);
  const [AQErrors, SetAQErrors] = useState({});

  const [GetEditorValue, SetGetEditorValue] = useState(
    updateScenario?.scenarioName
  );
  const [OtherComents, SetOtherComents] = useState(
    updateScenario?.qsOthersComments
  );

  const [DisplayDD, SetDisplayDD] = useState(updateScenario?.engType || "RC");
  const [SLevelOne, SetSLevelOne] = useState(updateScenario?.situation);
  const [TFormat, SetTFormat] = useState(updateScenario?.text_Format);
  const [TexType, SetTexType] = useState(updateScenario?.text_Type);
  const [Grade, SetGrade] = useState({
    display: updateScenario?.gradeName,
    value: updateScenario?.englishGrade,
  });
  const [Chapter, SetChapter] = useState(updateScenario?.unit);
  const [Book, SetBook] = useState(updateScenario?.book);
  const [BType, SetBType] = useState({
    display: updateScenario?.gcTypeName,
    value: updateScenario?.gcTypeId,
  });
  const [BSUB, SetBSUB] = useState({
    MR: updateScenario?.mainReading || "",
    Poem: updateScenario?.mainReadingPoem || "",
    NDL: updateScenario?.nonDetailedLesson || "",
  });
  const [BTSUB, SetBTSUB] = useState({
    SS: updateScenario?.shortstoriesId || "",
    Poem: updateScenario?.mainReadingPoem || "",
    NFI: updateScenario?.nonFictionIntroductionId || "",
    DI: updateScenario?.dramaIntroductionId || "",
    Essay: updateScenario?.essayId || "",
  });

  const [UNitNumber, SetUNitNumber] = useState(
    updateScenario?.unitNumber || ""
  );
  const [UNitName, SetUNitName] = useState(updateScenario?.unitName || "");
  const [SStage, SetSStage] = useState(updateScenario?.stage || "");
  const [SCGoal, SetSCGoal] = useState(updateScenario?.curricularGoal || "");
  const [Competencie, SetCompetencie] = useState(updateScenario?.competency || "");

  const [OpenDeatils, SetOpenDeatils] = useState(false);
  const [FSCGoal, SetFSCGoal] = useState();
  const [FCompetencie, SetFCompetencie] = useState();
  useMemo(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [AQErrors]);
  const AddScenario = async () => {
    if (GetEditorValue?.length > 0) {
      SetLoad((prev) => !prev);
      const ScenarioDetails = {
        scenario: GetEditorValue.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
        subjectID: parseInt(items?.subjectId),
        mainSourceLovId: NTDeatils,
        sSourceId: NTBased,
        OtherScenarioComments: OtherComents,
        createdBy: items?.userId,
        situationLevelOne: SLevelOne,
        textFormat: TFormat,
        textType: TexType,
        englishGrade: Grade?.value,
        unit: Chapter,
        book: Book,
        gcType: BType?.value,
        mainReading: BSUB?.MR || 0,
        nonDetailedLesson: BSUB?.NDL || 0,
        mainReadingPoem: BSUB?.Poem || BTSUB?.Poem || 0,
        medium: 0,
        enviornment: 0,
        EngType: DisplayDD,
        shortstories: BTSUB?.SS || 0,
        nonFictionIntroduction: BTSUB?.NFI || 0,
        dramaIntroduction: BTSUB?.DI || 0,
        essays: BTSUB?.Essay || 0,
        UnitNumber: UNitNumber || 0,
        UnitName: UNitName || 0,
        addScenarioQuestionChecklist: SCValues,
        stage: SStage || 0,
        curricularGoal: SCGoal || 0,
        competency: Competencie || 0,
      };
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + `/Scenario/AddLanguageScenario`,
          ScenarioDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          if (res.data >= 2) {
            notify("Scenario added successfully", "success");
            navigate(-1);
          } else {
            notify("Scenario already exists", "error");
          }
        })
        .catch((err) => {
          notify("Scenario not added. Please try again", "error");
        });
      SetLoad((prev) => !prev);
    } else {
      notify("Scenario field is required", "warning");
    }
  };
  const EditScenario = async () => {
    SetLoad((prev) => !prev);
    const ScenarioDetails = {
      scenario: GetEditorValue.replace(/(<p>(&nbsp;|\s)*<\/p>\s*)+$/g, ''),
      subjectID: items?.subjectId,
      mainSourceLovId: NTDeatils,
      sSourceId: NTBased,
      otherScenarioComments: OtherComents,
      ModifiedBy: items?.userId,
      ScenarioID: updateScenario?.scenarioID,
      situationLevelOne: SLevelOne,
      textFormat: TFormat,
      textType: TexType,
      englishGrade: Grade?.value,
      unit: Chapter,
      book: Book,
      gcType: BType?.value,
      mainReading: BSUB?.MR || 0,
      nonDetailedLesson: BSUB?.NDL || 0,

      // mainReadingPoem: BSUB?.Poem || BTSUB?.Title === "Poem" ? BTSUB.Value : 0,
      mainReadingPoem:
        BType?.display !== BTElective
          ? (BSUB?.Poem || 0)
          : (BTSUB?.Poem || 0),

      medium: 0,
      enviornment: 0,
      EngType: DisplayDD,
      shortstories: BTSUB?.SS || 0,
      nonFictionIntroduction: BTSUB?.NFI || 0,
      dramaIntroduction: BTSUB?.DI || 0,
      essays: BTSUB?.Essay || 0,
      UnitNumber: UNitNumber || 0,
      UnitName: UNitName || 0,
      AddScenarioQuestionChecklist: SCValues,
      stage: SStage || 0,
      curricularGoal: SCGoal || 0,
      competency: Competencie || 0,
    };
    await axios
      .post(
        process.env.REACT_APP_API_BASE_URL + `/Scenario/UpdateLanguageScenario`,
        ScenarioDetails,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        notify("Scenario updated successfully", "success");
        navigate(-1);
      })
      .catch((err) => {
        notify("Scenario not updated - Please try again", "error");
      });

    SetLoad((prev) => !prev);
  };

  const HandleDisplay = (e) => {
    SetDisplayDD(e);
    SetSLevelOne(0);
    SetTFormat(0);
    SetTexType(0);
    SetChapter(0);
    SetBook(0);
    SetBSUB(0);
    SetBTSUB(0);
  };
  const validationSchema = Yup.object().shape({
    NTBased: Yup.string().required("Source is required"),
    NTDeatils: Yup.string().required("Source is required"),
    GetEditorValue: Yup.string().required("Scenario is required"),
    // Grade: Yup.string().required("Grade  is required"),
    Grade: Yup.object({
      value: Yup.string()
        .required("Grade is required")
        .matches(/^-?\d+$/, "Grade must be a number") // only digits allowed (handles negatives too)
        .test("is-greater", "Grade is required", function (value) {
          if (!value) return false; // catches empty
          return parseInt(value, 10) > 0;
        }),
    }),
    UNitNumber: Yup.string().when("DisplayDD", {
      is: () =>
        DisplayDD === "RC" &&
        (Grade?.display === "1" ||
          Grade?.display === "2" ||
          Grade?.display === "Pre-primary"),
      then: (schema) => Yup.string().required("Unit Number is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    UNitName: Yup.string().when("DisplayDD", {
      is: () =>
        DisplayDD === "RC" &&
        (Grade?.display === "1" ||
          Grade?.display === "2" ||
          Grade?.display === "Pre-primary"),
      then: (schema) => Yup.string().required("UNit Name is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Chapter: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Chapter is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    Book: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Book is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    SLevelOne: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Situation is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    TFormat: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Text Format is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    TexType: Yup.string().when("DisplayDD", {
      is: () => DisplayDD === "RC",
      then: (schema) => Yup.string().required("Text Type is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    SStage: Yup.string().required("Stage is required"),
    SCGoal: Yup.string().required("Curricular Goal is required"),
    Competencie: Yup.string().required("Competencies is required"),
  });
console.log(SStage,
    SCGoal,
    Competencie)
  const MainValidation = () => {
    const AllFields = {
      DisplayDD,
      NTBased,
      NTDeatils,
      GetEditorValue,
      Grade,
      Chapter,
      Book,
      SLevelOne,
      TFormat,
      TexType,
      UNitNumber,
      UNitName, SStage, SCGoal, Competencie,
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then((validData) => {
        SetAQErrors({});
        if (CValidation) {
          Validation();
        }
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };

  const Validation = () => {
    if (DisplayDD !== "G") {
      if (BType?.display !== BTElective) {
        if (BSUB.MR || BSUB.Poem || BSUB.NDL) {
          if (updateScenario) {
            EditScenario();
          } else {
            AddScenario();
          }
        } else {
          notify(
            "Please select any one of the fields - Main Reading, Poem, or Non-Detailed Lesson",
            "warning"
          );
        }
      } else if (
        BTSUB.SS ||
        BTSUB.Poem ||
        BTSUB.NFI ||
        BTSUB.DI ||
        BTSUB.Essay
      ) {
        if (updateScenario) {
          EditScenario();
        } else {
          AddScenario();
        }
      } else {
        notify(
          `Please select any one of the fields - Short Stories,Poem,  ${Grade?.value === 51 ? "Essay" : "Non-Fiction,Drama"
          }`,
          "warning"
        );
      }
    } else {
      if (updateScenario) {
        EditScenario();
      } else {
        AddScenario();
      }
    }
  };

  const ClearSUbDD = (e) => {
    // SetGrade(e);
    SetUNitNumber("");
    SetUNitName("");
    SetBSUB({ MR: "", Poem: "", NDL: "" });
    SetBTSUB({ SS: "", Poem: "", NFI: "", DI: "", Essay: "" });
  };
  const [HitCLV, SetHitCLV] = useState(false);
  const [CValidation, SetCValidation] = useState(false);
  const [SCValues, SetSCValues] = useState();
  useEffect(() => {
    if (CValidation &&  Object.keys(AQErrors).length === 0) {
      Validation();
    }
  }, [CValidation]);
    const Columns = [
    { name: "Code", selector: "lovName", sortable: true },
    {
      name: "Description", selector: "lovDescription", sortable: true,
      cell: (row) => (<div style={{ textAlign: "justify" }}>{row.lovDescription} </div>),
    },
  ];
  return (
    <>
      <div className="MainHeading">
        {updateScenario ? "Update" : "Add"} Scenario
      </div>
      <div className="Card mt-2">
        <div className="AddOptions">
          <div className="dflex alignitems AUTitles">
            <div className="dflex alignitems">
              {" "}
              <img src={AP} alt="Learning Outcomes" />{" "}
              <div>
                Scenario Source<span className="text-danger">*</span>{" "}
              </div>
            </div>{" "}
          </div>
          <div className="container-fluid mt-3">
            <Row>
              <Col>
                {" "}
                <MainSource
                  className="NCLDropdown w-100"
                  StoreMSource={SetNTDeatils}
                  SOption={NTDeatils}
                  onChange={(e) => SetNTDeatils(e)}
                  LID={SelectLanguage}
                />{" "}
                {AQErrors?.NTDeatils && (
                  <span className="error-message">{AQErrors?.NTBased}</span>
                )}
              </Col>
              <Col>
                {" "}
                <SubMainSource
                  className="NCLDropdown w-100"
                  StoreSMSource={SetNTBased}
                  SOption={NTBased}
                  PId={NTDeatils}
                  onChange={(e) => SetNTBased(e)}
                  LID={SelectLanguage}
                />
                {AQErrors?.NTBased && (
                  <span className="error-message">{AQErrors?.NTBased}</span>
                )}
                {(NTBased === "3574" || NTBased === "3578") && (
                  <input
                    type="text"
                    className=" Search mt-2 p-1 w-100"
                    onChange={(e) => SetOtherComents(e.target.value)}
                    placeholder="Enter Comments"
                  />
                )}
              </Col>
            </Row>
          </div>
        </div>
        <div className="dflex  mt-3" style={{ gap: "15px" }}>
          {["RC", "G"].map((Item) => (
            <div key={Item} className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                value={Item}
                name="NSBased"
                disabled={updateScenario}
                checked={DisplayDD === Item}
                onChange={() => HandleDisplay(Item)}
              />{" "}
              <b>{Item === "G" ? "Grammar" : "Reading Comprehension"}</b>
            </div>
          ))}
        </div>

        {DisplayDD !== "G" && (
          <div className="AddOptions">
            <div className="dflex alignitems AUTitles">
              <div className="dflex alignitems">
                {" "}
                <img src={AP} alt="Learning Outcomes" />{" "}
                <div>
                  Assessment Parameters<span className="text-danger">*</span>{" "}
                </div>
              </div>{" "}
            </div>

            <div className="container-fluid">
              <Row>
                <Col>
                  {" "}
                  <Situation
                    className="NCLDropdown w-100" SID={items?.subjectId} LID="33"
                    Displayname="Select Situation"
                    StoreMSource={SetSLevelOne}
                    SOption={SLevelOne}
                    onChange={(e) => SetSLevelOne(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Situation<span>*</span>
                      </div>
                    }
                  />
                  {AQErrors?.SLevelOne && (
                    <span className="error-message">{AQErrors?.SLevelOne}</span>
                  )}
                </Col>
                <Col>
                  {" "}
                  <TextFormat
                    Displayname="Select Text Format" SID={items?.subjectId} LID="33"
                    className="NCLDropdown w-100"
                    StoreMSource={SetTFormat}
                    SOption={TFormat}
                    onChange={(e) => SetTFormat(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Text Format<span>*</span>
                      </div>
                    }
                  />
                  {AQErrors?.TFormat && (
                    <span className="error-message">{AQErrors?.TFormat}</span>
                  )}
                </Col>
                <Col>
                  {" "}
                  <TType
                    Displayname="Select Text Type" SID={items?.subjectId} LID="33"
                    className="NCLDropdown w-100"
                    StoreMSource={SetTexType}
                    SOption={TexType}
                    onChange={(e) => SetTexType(e)}
                    labelname={
                      <div className="DropdownHeader">
                        Text Type<span>*</span>
                      </div>
                    }
                  />
                  {AQErrors?.TexType && (
                    <span className="error-message">{AQErrors?.TexType}</span>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        )}

        <div className="AddOptions">
          <div className="dflex alignitems AUTitles">
            <div className="dflex alignitems">
              {" "}
              <img src={AP} alt="Learning Outcomes" />{" "}
              <div>
                Grade and Curriculum Mapping
                <span className="text-danger">*</span>{" "}
              </div>
            </div>{" "}
          </div>
          <div className="container-fluid">
            <Row>
              <Col>
                <GradeDD
                  Change={true}
                  Displayname="Select Grade"
                  className="NCLDropdown w-100"
                  StoreMSource={SetGrade}
                  SOption={Grade?.value}
                  onChange={(e) => ClearSUbDD(e)}
                  labelname={
                    <div className="DropdownHeader">
                      Grade<span>*</span>
                    </div>
                  }
                />
                {AQErrors?.["Grade.value"] && (
                  <span className="error-message">
                    {AQErrors?.["Grade.value"]}
                  </span>
                )}
              </Col>

              <Col>
                <div style={DisplayDD === "G" ? { display: "none" } : {}}>
                  <Booktype
                    className={`w-100 ${Grade?.value === 52 || Grade?.value === 51
                      ? "NCLDropdown"
                      : "DisabledNCLDropdown"
                      }`}
                    StoreMSource={SetBType}
                    SOption={BType}
                    Grade={Grade?.value}
                    onChange={(e) => SetBType(e)}
                    disable={Grade?.value !== 52 && Grade?.value !== 51}
                    labelname={
                      <div className="DropdownHeader">
                        Book Type<span>*</span>
                      </div>
                    }
                  />{" "}
                </div>
              </Col>
            </Row>
            {/* {Grade}=== */}
            {(
              Grade?.display === "1" ||
              Grade?.display === "2" ||
              Grade?.display === "Pre-primary") &&
              DisplayDD !== "G" && (
                <Row>
                  <Col>
                    <UnitNumber SID={items?.subjectId} LoID="74"
                      className="NCLDropdown w-100"
                      Displayname="Select Unit Number"
                      PID={Grade?.value}
                      LID={SelectLanguage}
                      StoreMSource={SetUNitNumber}
                      SOption={UNitNumber}
                      onChange={(e) => SetUNitNumber(e)}
                      labelname={
                        <div className="DropdownHeader">
                          {" "}
                          Unit Number<span>*</span>{" "}
                        </div>
                      }
                    />
                    {AQErrors?.UNitNumber && (
                      <span className="error-message">
                        {AQErrors?.UNitNumber}
                      </span>
                    )}
                  </Col>
                  <Col>
                    <UnitName SID={items?.subjectId} LoID="75"
                      className="NCLDropdown w-100"
                      Displayname="Select Unit Name"
                      PID={UNitNumber}
                      LID={SelectLanguage}
                      StoreMSource={SetUNitName}
                      SOption={UNitName}
                      onChange={(e) => SetUNitName(e)}
                      labelname={
                        <div className="DropdownHeader">
                          {" "}
                          Unit Name<span>*</span>{" "}
                        </div>
                      }
                    />
                    {AQErrors?.UNitName && (
                      <span className="error-message">
                        {AQErrors?.UNitName}
                      </span>
                    )}
                  </Col>
                </Row>
              )}
            <Row>
              {DisplayDD !== "G" ? (
                <>
                  <Col>
                    {" "}
                    <ChapterDD LID="50"
                      Displayname="Select Chapter"
                      className="NCLDropdown w-100"
                      StoreMSource={SetChapter}
                      SOption={Chapter}
                      onChange={(e) => SetChapter(e)}
                      labelname={
                        <div className="DropdownHeader">
                          CBSE / SCERT Chapter No<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.Chapter && (
                      <span className="error-message">{AQErrors?.Chapter}</span>
                    )}
                  </Col>
                  <Col>
                    {" "}
                    <BookDD
                      Displayname="Select Book"
                      className="NCLDropdown w-100"
                      Grade={Grade?.value}
                      Chapter={Chapter}
                      GCtype={BType?.value}
                      StoreMSource={SetBook}
                      SOption={Book}
                      onChange={(e) => SetBook(e)}
                      labelname={
                        <div className="DropdownHeader">
                          Book<span>*</span>
                        </div>
                      }
                    />
                    {AQErrors?.Book && (
                      <span className="error-message">{AQErrors?.Book}</span>
                    )}
                  </Col>
                </>
              ) : (
                <>
                  <Col></Col>
                  <Col></Col>
                </>
              )}{" "}
            </Row>

            {DisplayDD !== "G" && (
              <>
                {BType?.display !== BTElective ? (
                  <BookSubDropDowns
                    className="NCLDropdown w-100"
                    Grade={Grade?.value}
                    Chapter={Chapter}
                    Book={Book}
                    GCtype={BType?.value}
                    StoreMSource={SetBSUB}
                    SOption={BSUB}
                    ref={BookRef}
                  />
                ) : (
                  <BookTypeSubDropDowns
                    className="NCLDropdown w-100"
                    Grade={Grade?.value}
                    Chapter={Chapter}
                    Book={Book}
                    GCtype={BType?.value}
                    StoreMSource={SetBTSUB}
                    SOption={BTSUB}
                    ref={BookTypeRef}
                  />
                )}
              </>
            )}
          </div>
        </div>

        <div className="AddOptions">
          <div className="dflex alignitems AUTitles">
            <div className="dflex alignitems">
              {" "}
              <img src={AP} alt="Learning Outcomes" />{" "}
              <div> Competencies<span className="text-danger">*</span></div>
            </div>{" "}
          </div>
          <div className="container-fluid">
            <Row>
              <Col>
                <StageDD className="NCLDropdown w-100" StoreMSource={SetSStage} SOption={SStage}
                  onChange={(e) => {SetSStage(e);SetSCGoal("");SetCompetencie("");SetFCompetencie("");}} Displayname="Select Stage" LID="79" SID={items?.subjectId}
                  labelname={<div className="DropdownHeader"> Stage<span>*</span> </div>} />
                {AQErrors?.SStage && (<span className="error-message"> {AQErrors?.SStage} </span>)}
              </Col>
              <Col>
                <CircularGoalDD className="NCLDropdown w-100" StoreMSource={SetSCGoal} SOption={SCGoal} PId={SStage}
                  onChange={(e) => {SetSCGoal(e);SetCompetencie("");}} Displayname="Select Curricular Goal" LID="80" SID={items?.subjectId}
                  labelname={<div className="DropdownHeader"> Curricular Goal<span>*</span> </div>} GetDetails={SetFSCGoal} />
                {AQErrors?.SCGoal && (<span className="error-message"> {AQErrors?.SCGoal} </span>)}
                <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                  onClick={() => SetOpenDeatils(FSCGoal)}
                > <IoInformationCircleOutline /> Click to view Curricular Goal description </div>
              </Col>
              <Col>
                <CompetenciesDD className="NCLDropdown w-100" StoreMSource={SetCompetencie} SOption={Competencie} PId={SCGoal}
                  onChange={(e) => SetCompetencie(e)} Displayname="Select Competencies" LID="81" SID={items?.subjectId}
                  labelname={<div className="DropdownHeader"> Competencies<span>*</span> </div>} GetDetails={SetFCompetencie}/>
                {AQErrors?.Competencie && (<span className="error-message"> {AQErrors?.Competencie} </span>)}
                <div className="dflex alignitems CPointer gap-1 mt-1" style={{ fontSize: "10px" }}
                  onClick={() => SetOpenDeatils(FCompetencie)}
                > <IoInformationCircleOutline /> Click to view Competencies description </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="m-2">
          Scenario <span className="text-danger">*</span>
        </div>

        <TinyMCEDitor
          onChange={(e) => SetGetEditorValue(e)}
          PostValue={GetEditorValue}
        />
        {AQErrors?.GetEditorValue && (
          <span className="error-message">{AQErrors?.GetEditorValue}</span>
        )}

        <QBCList Heading="Scenario" HValidation={HitCLV} RStoreHValidation={SetHitCLV} VSuccess={SetCValidation}
          GetValues={SetSCValues} Existinvalues={updateScenario?.status} ExistingId={updateScenario?.checklistQuestionId} LanguageId={SelectLanguage} />

        <div className="ScenarioAU dflex alignitems">
          <button className="Buttons bg-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button className="Buttons bg-success" onClick={() => { MainValidation(); SetHitCLV(true); }}>
            {updateScenario ? (
              <>
                Update{" "}
                <span style={{ fontSize: "8px" }}>
                  (Please go Through The Below Checklist Before Updating The
                  Scenario)
                </span>
              </>
            ) : (
              "Save"
            )}{" "}
          </button>
        </div>
      </div>
{OpenDeatils && (
        <div className="Model-Open">
          <div className="Card w-100 Model-Content">
            <IoMdCloseCircleOutline
              className="NCERTClose CPointer"
              onClick={() => SetOpenDeatils()}
            />
            <DataTable data={OpenDeatils} columns={Columns} className="NCLDataTable"
              Dropdownvalues={["10", "25", "50", "100"]} ShowPagination="true" ShowPagecount="true" />
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default EAddEditScenario;
